import { createStore } from 'zustand-x';

export const goBackStore = createStore('goBack')(
  {
    canGoBack: false,
    isPopupOpen: false,
    isOpen: false,
  },
  { devtools: { enabled: true } }
).extendActions((set) => ({
  goBack: () => {
    set.canGoBack(true);
  },
  dontGoBack: () => {
    set.canGoBack(false);
  },
  closePopup: () => {
    set.isPopupOpen(false);
  },
  openPopup: () => {
    set.isPopupOpen(true);
  },
  close: () => {
    set.isOpen(false);
  },
  open: () => {
    set.isOpen(true);
  },
}));
